import * as React from 'react';
import { Modal, LoadingOverlayWrapper, PortalInput, WhiteButton, Button } from 'components';
import { PortalPageSection, ButtonsSection } from 'components/PortalStructure';
import { PortalFieldLabel } from 'components/FormControls';
const InfiniteScroll = require('react-infinite-scroll-component');
require('./style.css');

interface IProps {
	title: string;
	placeholder?: string;
	searchValue: string;
	onSearchValueChange: any;
	infiniteScrollProps: any;
	showHeaderCloseButton: boolean;
	closeModal: () => void;
	renderLoader: boolean;
	loaderText: string;
	radioButtonInputs: any;
	searchButtonText: string;
	okButtonText: string;
	searchFunction: () => void;
	onSubmit: () => void;
}

/**
 *
 * @param props
 */
export const EntitySearch = (props: IProps) => {
	return (
		<Modal
			modalClass="searchEntityModal"
			title={props.title}
			showHeaderCloseButton={props.showHeaderCloseButton}
			closeModal={props.closeModal}
		>
			<LoadingOverlayWrapper
				active={props.renderLoader}
				spinner={true}
				text={props.loaderText}
				background="rgba(0, 0, 0, 0.1)"
			>
				<PortalPageSection usage="admin">
					<div className="row">
						<div className="col-sm-12">
							<PortalFieldLabel name="search" text={props.title} />
						</div>
					</div>
					<div className="row">
						<div className="col-sm-8">
							<PortalInput
								usage="admin"
								type="text"
								name="search"
								value={props.searchValue}
								onChangeAction={props.onSearchValueChange}
								placeholder={props.placeholder}
								autoFocus={true}
							/>
						</div>
						<div className="col-sm-4">
							<WhiteButton type="submit" usage="admin" onClick={props.searchFunction}>
								{props.searchButtonText}
							</WhiteButton>
						</div>
					</div>

					<InfiniteScroll {...props.infiniteScrollProps}>
						<div className="entitiesList">{props.radioButtonInputs}</div>
					</InfiniteScroll>
				</PortalPageSection>
				<ButtonsSection>
					<div className="row">
						<div className="col-sm-12">
							<Button usage="admin" onClick={props.onSubmit}>
								{props.okButtonText}
							</Button>
						</div>
					</div>
				</ButtonsSection>
			</LoadingOverlayWrapper>
		</Modal>
	);
};
